import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import FilterIcon from '@material-ui/icons/FilterList'
import SaveIcon from '@material-ui/icons/SaveAlt'

import PaperBlock from "../../../ui/PaperBlock"

/**
 * selected
 * 
 * onAttachItemClick()
 * onAttachTemplateClick()
 * onRemoveItemClick(attachment)
 * onEditClick(attachment)
 * onFilterClick()
 * onSaveClick()
 */

class ControlPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			anchorEl: null,
			appendButtonTooltipOpenState: false,
		}
	}

    render() {
        return <PaperBlock style = {{display: "flex"}}>

            <Tooltip
				title = "Добавить"
				open={this.state.appendButtonTooltipOpenState}
				disableHoverListener
				disableFocusListener
				onMouseEnter={() => {this.setState({appendButtonTooltipOpenState: true})}}
				onMouseLeave={() => {this.setState({appendButtonTooltipOpenState: false})}}
			><div>
				<Button
					aria-owns = {this.state.anchorEl ? 'add-item-menu' : undefined}
					aria-haspopup = "true"
					onClick = {e => {
						e.stopPropagation()
						this.setState({
							anchorEl: e.currentTarget,
						})
					}}					
				>
					<AddIcon />
				</Button>
			</div></Tooltip>

			<Menu
				id = 'add-item-menu'
				anchorEl = {this.state.anchorEl}
				open = {Boolean(this.state.anchorEl)}
				onClose = {e => {
					this.setState({anchorEl: null,})
				}}
			>

				<MenuItem onClick = {e => {
					e.stopPropagation()
					this.setState({
						anchorEl: null,
					}, () => {
						if (typeof this.props.onAttachItemClick === "function") {
							this.props.onAttachItemClick()
						}
					})
				}}>Добавить предмет</MenuItem>

				<MenuItem onClick = {e => {
					e.stopPropagation()
					this.setState({
						anchorEl: null,
					}, () => {
						if (typeof this.props.onAttachTemplateClick === "function") {
							this.props.onAttachTemplateClick()
						}
					})
				}}>Добавить из шаблона</MenuItem>

			</Menu>

            <Tooltip title = "Редактировать"><div>
				<Button
                    disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditClick === "function") {
							this.props.onEditClick(this.props.selected)
						}
					}}
				>
					<EditIcon />
				</Button>
			</div></Tooltip>

            <Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onRemoveItemClick === "function") {
							this.props.onRemoveItemClick(this.props.selected)
						}
					}}
				>
					<DeleteIcon />
				</Button>
			</div></Tooltip>

            <Tooltip title = "Фильтр"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onFilterClick === "function") {
							this.props.onFilterClick()
						}
					}}
				>
					<FilterIcon />
				</Button>
			</div></Tooltip>

            <Tooltip title = "Сохранить"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onSaveClick === "function") {
							this.props.onSaveClick()
						}
					}}
				>
					<SaveIcon />
				</Button>
			</div></Tooltip>			

        </PaperBlock>
    }

}

export default ControlPanel